<template>
  <v-dialog
    v-model="show"
    max-width="900px"
  >
    <v-card>
      <v-card-title>
        Request For Refund
        <v-spacer></v-spacer>
        <v-btn
          icon
          blur
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-expansion-panels v-model="firstPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Attached files</v-expansion-panel-header>
            <v-expansion-panel-content>
              Please upload the receipt of the purchase.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mb-2">
          <v-col >
            <v-file-input
              label="Receipt"
              v-model="refundReceiptFile.file"
              @change="onRefundFileChange"
              :rules="fileRule"
              show-size
              counter
              accept=".doc, .docx, application/pdf, .jpg, application/msword, image/jpg"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-expansion-panels class="mb-1" v-model="secondPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Other fields</v-expansion-panel-header>
            <v-expansion-panel-content>
              How much did you pay for the refund?
                Are there some additional comments?
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row >
          <v-col cols="12" md="2" lg="2">
            <v-select
              v-model="currency"
              :prepend-icon="currency === currencies.USD.name ? 'mdi-currency-usd' : 'mdi-currency-uah'"
              :items="currencyNames"
              :disabled="refundType?.Type_ID === 1"
            >
          </v-select>
            <b class="ml-4">1$ = {{ NBUExchangeRate }}{{ currencies.UAH.sign }}</b>
          </v-col>
          <v-col cols="12" lg="2" md="2">
            <v-text-field
              v-model="computedAmountSpent"
              class="inputAmount"
              :label="refundType?.Type_ID === 2 ? 'Sum (1000$ max)': 'Amount spent'"
              :disabled="refundType?.Type_ID === 1"
              type="number"
              :rules="refundType?.Type_ID === 2 ? amountFullRules : amountSpentRules"
              min="1"
            >
            </v-text-field>
            <b v-if="refundType?.Type_ID === 1">$50 per month</b>
          </v-col>
          <v-col cols="12" :md="refundType?.Name === 'Taxi' ? 2 : 4" :lg="refundType?.Name === 'Taxi' ? 2 : 4">
            <v-select
              v-model="refundType"
              label="Refund type"
              :items="refundTypes"
              item-text="Name"
              @change="changeRefundType"
              return-object
            ></v-select>
          </v-col>
          <v-col v-if="refundType?.Name === 'Taxi'" cols="12" :md="refundType?.Name === 'Taxi' ? 3 : 4" :lg="refundType?.Name === 'Taxi' ? 3 : 4">
            <v-select
              :items="filteredAccountManagers"
              label="Account Manager"
              item-value="Employee_ID"
              item-text="Full_Name"
              v-model="accountManager"
            >
              <template v-slot:prepend-item>
                <div class="px-4 py-2">
                  <v-text-field
                    dense
                    hide-details
                    label="Search Approver"
                    v-model="searchAM"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" :md="refundType?.Name === 'Taxi' ? 2 : 3" :lg="refundType?.Name === 'Taxi' ? 3 : 4">
            <v-textarea
              v-model="comments"
              rows="1"
              label="Comments (optional)"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small :loading="isLoading" :disabled="isLoading || !isRequestReady() || !isRequestAppropriate" @click="sendRequest" color="primary">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RefundRequest',
  props: {
    value: {
      required: true,
      default: false
    },
    requestId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isRequestAppropriate: true,
      isLoading: false,
      firstPanel: 0,
      isNewConfirmationFile: false,
      refundType: null,
      refundTypes: [],
      accountManagers: [],
      accountManager: null,
      searchAM: '',
      NBUExchangeRate: null,
      currency: 'USD',
      currencyNames: ['USD', 'UAH'],
      currencies: {
        USD: {
          sign: '$',
          name:
            'USD'
        },
        UAH: {
          sign: '₴',
          name:
            'UAH'
        }
      },
      CEO: null,
      CEOId: 2,
      secondPanel: 0,
      refundReceiptFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      amount_Of_Compensation: null,
      comments: null,
      notificationData: {
        Notification_Type_ID: 1,
        Notification_Title: '',
        Notification_Message: '',
        Notification_Created: undefined,
        Notification_Employee_ID_From: undefined,
        Notification_Employee_ID_To: undefined
      }
    }
  },
  async mounted () {
    this.getAccountManagers()
    await this.getNBUExchangeRate()
    this.getCompensationTypes()
    if (this.requestId) {
      this.getRefundRequest(this.requestId)
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (this.value) {
          this.clearAll()
          this.$emit('getHistory')
          this.isRequestAppropriate = true
        }
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    filteredAccountManagers () {
      const r = new RegExp(this.searchAM, 'gi')
      return this.accountManagers.filter(item => {
        r.lastIndex = 0
        return r.test(item.Full_Name)
      })
    },
    computedAmountSpent: {
      get () {
        return this.amount_Of_Compensation
      },
      set (val) {
        if (val < 0) {
          this.amount_Of_Compensation = -val
        } else {
          this.amount_Of_Compensation = val
        }
      }
    },
    fileRule () {
      return [
        v => !!v || 'File is required'
      ]
    },
    amountSpentRules () {
      return [
        v => !!v || 'Amount spent is required',
        v => (v && v >= 1) || 'Amount spent must be greater than or equal to 1'
      ]
    },
    amountFullRules () {
      return [
        v => (v && v >= 1 && v <= (this.currency === this.currencies.UAH.name ? 1000 * this.NBUExchangeRate : 1000)) || 'Max amount is 1000$ or equivalent in ₴'
      ]
    }
  },
  methods: {
    sendRequest () {
      this.isLoading = true
      this.isRequestAppropriate = false
      const compensationAmount = this.currency === this.currencies.USD.name
        ? this.computedAmountSpent
        : this.computedAmountSpent / this.NBUExchangeRate

      const headers = {
        Authorization: `Bearer ${this.user.token}`
      }

      const basePayload = {
        Confirmation_File: this.refundReceiptFile,
        Amount_Of_Compensation: compensationAmount,
        Comments: this.comments,
        Refund_Type_ID: this.refundType.Type_ID,
        isNewConfirmationFile: this.isNewConfirmationFile
      }

      const onError = (error) => {
        this.isRequestAppropriate = true
        const errorMsg = `${error.message} - ${error?.response?.data || 'Unknown error'}`
        this.$store.dispatch('setError', { errorMsg })
      }

      if (this.requestId) {
        this.axios.put(`/api/requests/refund_by_id/${this.requestId}`, basePayload, { headers })
          .then((res) => {
            this.$store.dispatch('setSuccess', { successMsg: 'Refund request details were updated.' })
            return this.axios.delete(`/api/notifications/${res.data[0].Notification_ID}`, { headers })
          })
          .then(() => {
            return this.createRefundNotification()
          })
          .then((newNotificationResponse) => {
            const newNotificationId = newNotificationResponse.data[0].Notification_ID
            return this.axios.put(`/api/requests/update_notification_refund_request/${this.requestId}`, { Notification_ID: newNotificationId }, { headers })
          })
          .then(() => {
            this.sendEmailAboutRefundRequest(this.requestId)
            this.show = false
            this.$store.dispatch('setSuccess', { successMsg: 'Refund request was fully updated.' })
          })
          .catch(onError).finally(() => {
            this.isLoading = false
          })
      } else {
        this.createRefundNotification()
          .then(response => {
            const newNotificationId = response.data[0].Notification_ID

            const payload = {
              ...basePayload,
              Creator_ID: this.user.employee_id,
              Confirmer_ID: this.refundType?.Name === 'Taxi' ? this.accountManager : this.CEOId,
              Payout_Month: new Date().toISOString().substr(0, 10),
              Notification_ID: newNotificationId
            }

            return this.axios.post('/api/requests/refund', payload, { headers })
          })
          .then(result => {
            const newRequestId = result.data[0].Request_ID
            this.sendEmailAboutRefundRequest(newRequestId)
            this.show = false
            this.$store.dispatch('setSuccess', { successMsg: 'Request for refund was made' })
          })
          .catch(onError).finally(() => {
            this.isLoading = false
          })
      }
    },
    getCompensationTypes () {
      this.axios.get('/api/refund_compensation_types', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.refundTypes = this.accountManagers.some(item => item.Employee_ID === this.user.employee_id)
          ? res.data
          : res.data.filter(item => item.Name !== 'Teambuilding')
      }).catch(err => {
        this.$store.dispatch('setError', { errorMsg: err.message + ' - ' + err.response.data })
      })
    },
    getRefundRequest (requestId) {
      this.axios.get(`/api/requests/refund_by_id/${requestId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const data = res.data[0]

        this.refundType = {
          Name: data.Refund_Type,
          Type_ID: data.Refund_Type_ID
        }
        this.accountManager = data.Confirmer_ID
        this.computedAmountSpent = data.Amount_Of_Compensation
        this.comments = data.Comments

        this.refundReceiptFile.File_Name = data.Confirmation_File_Name
        this.refundReceiptFile.File_Type = data.Confirmation_File_Type

        this.getRefundFile(requestId, 'Confirmation_File')
      }).catch(err => {
        this.$store.dispatch('setError', {
          errorMsg: err.message + ' - ' + (err.response?.data || '')
        })
      })
    },
    getRefundFile (requestId, kindOfFile) {
      this.axios.get(`/api/requests/refund_file/${requestId}/${kindOfFile}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const raw = res.data[0].File

        const fileName = this.refundReceiptFile.File_Name
        const fileType = this.refundReceiptFile.File_Type

        const byteArray = new Uint8Array(raw.data)
        const restoredFile = new File([byteArray], fileName, { type: fileType })

        this.refundReceiptFile.file = restoredFile

        this.onFileChange(restoredFile, this.refundReceiptFile)
        this.isNewConfirmationFile = false
      }).catch(error => {
        this.$store.dispatch('setError', {
          errorMsg: error.message + ' - ' + (error.response?.data || '')
        })
      })
    },
    onRefundFileChange (e) {
      this.onFileChange(e, this.refundReceiptFile)
    },
    changeRefundType () {
      if (this.refundType?.Type_ID === 1) {
        this.computedAmountSpent = 50
        this.currency = this.currencies.USD.name
      }
    },
    getAccountManagers () {
      this.axios.get('/api/requests/list-of-am', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.accountManagers = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    sendEmailAboutRefundRequest (requestID) {
      this.axios.post('/api/emails/sendemailaboutrefundrequest', {
        Request_ID: requestID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onFileChange (e, file) {
      if (e) {
        const reader = new FileReader()
        reader.onload = () => {
          file.file.data = reader.result
          let binary = ''
          const bytes = new Uint8Array(file.file.data)
          const len = bytes.byteLength
          for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          file.file.base64String = `data:${e.type};base64, ${window.btoa(binary)}`
        }
        file.File_Name = e.name
        file.File_Type = e.type
        reader.readAsArrayBuffer(e)
        this.isNewConfirmationFile = true
      }
    },
    createRefundNotification () {
      const confirmerId = this.refundType?.Name === 'Taxi' ? this.accountManager : this.CEOId

      const notificationData = {
        Notification_Message: `
          Requester:  ${this.user.full_name},
          Refund amount: ${this.amount_Of_Compensation} ${this.currency},
          Reason: ${this.comments || '(no comments)'}.
        `,
        Notification_Title: `Refund request for ${this.user.full_name}`,
        Notification_Created: new Date().toISOString().slice(0, 10),
        Notification_Employee_ID_From: this.user.employee_id,
        Notification_Employee_ID_To: confirmerId,
        Notification_Type_ID: 1
      }

      const headers = {
        Authorization: 'Bearer ' + this.user.token
      }

      return this.axios.post('/api/notifications', notificationData, { headers })
    },
    isRequestReady () {
      const isAmountValid = this.refundType?.Type_ID === 2
        ? this.amountFullRules.every(rule => rule(this.amount_Of_Compensation) === true)
        : this.amount_Of_Compensation

      const isTaxi = this.refundType?.Name === 'Taxi'
      const isAccountManagerValid = !isTaxi || !!this.accountManager

      return this.refundReceiptFile.file &&
         isAmountValid &&
         this.refundType?.Name &&
         isAccountManagerValid
    },
    clearAll () {
      this.refundReceiptFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.computedAmountSpent = null
      this.comments = null
    },
    async getNBUExchangeRate () {
      this.amount_Of_Compensation = null
      await this.axios.get('https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?valcode=USD&json=')
        .then(res => {
          if (res.status === 200 && res.data.length && res.data[0]?.rate && typeof res.data[0].rate === 'number') {
            this.NBUExchangeRate = res.data[0].rate
          } else {
            let errorMsg = 'NBU API Error: Invalid API response or data format'
            if (!res.data.length) errorMsg = 'NBU API Error: No data returned'
            if (res.data.length && !res.data[0]?.rate) errorMsg = 'NBU API Error: rate missing in response'
            if (res.data.length && res.data[0]?.rate && typeof res.data[0].rate !== 'number') errorMsg = 'NBU API Error: rate is not a number'

            this.$store.dispatch('setError', { errorMsg })
          }
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
    }
  }
}
</script>
<style>
.inputAmount input[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
}
.inputAmount input::-webkit-outer-spin-button,
.inputAmount input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
